import React from "react";
import { FormGroup, InputGroup, Callout, Intent } from "@blueprintjs/core";
import { AccountForm } from "../../molecules/AccountForms";
import { Link } from "react-router-dom";
import styles from "../InfluencerLogin/InfluencerLoginForm.module.scss";
import { Icon } from "../../atoms/Icon";
import { isEmail } from "validator";

function RegisterForm({
  error,
  disabled,
  location,
  onEmailChange,
  onPasswordChange,
  username,
  onUsernameChange,
  onNameChange,
  toggleShowPassword,
  showPassword,
  onSubmit,
  mutationLoading
}) {
  const bottomLinkComponent = (
    <div className={styles.registerWrapper}>
      <p className={styles.registerText}>
        By continuing, you agree to our&nbsp;
        <a href="https://videosquirrel.app/tos" target="_blank">
          Terms of Service
        </a>{" "}
        and&nbsp;
        <a href="https://videosquirrel.app/privacy" target="_blank">
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );

  const topLinkComponent = (
    <div className={styles.bottomTextWrapper}>
      <p className={styles.registerText}>
        Already have a VideoSquirrel Account?&nbsp;
        <Link
          to={{
            pathname: "/influencer/login",
            state: {
              from: location.state ? location.state.from : null
            }
          }}
        >
          Sign in{" "}
        </Link>
      </p>
    </div>
  );

  return (
    <AccountForm
      onSubmit={onSubmit}
      buttonText="Sign Up!"
      topLinkComponent={topLinkComponent}
      bottomLinkComponent={bottomLinkComponent}
      disabled={disabled}
      mutationLoading={mutationLoading}
      hideButton={true}
      smallButton={true}
    >
      {error && (
        <Callout
          intent={Intent.WARNING}
          title={error.title}
          style={{ marginBottom: "1em" }}
          icon={null}
        >
          {error.message}
        </Callout>
      )}

      <FormGroup label="Influencer Name" labelFor="name">
        <InputGroup id="name" type="text" onChange={onNameChange} />
      </FormGroup>

      <FormGroup label="Email Address" labelFor="email">
        <InputGroup id="email" type="email" onChange={onEmailChange} />
      </FormGroup>

      <FormGroup label="Username" labelFor="username">
        <InputGroup
          id="username"
          type="text"
          autoComplete="false"
          autoCapitalize="none"
          value={username}
          onChange={onUsernameChange}
        />
      </FormGroup>
      {username && isEmail(username) && (
        <div className={styles.invalidUsername}>
          <Icon name="cross" color="#ec7c7c" />
          <span className={styles.inValid}>Username can not be an email</span>
        </div>
      )}

      <FormGroup label="Password" labelFor="password-input">
        <InputGroup
          id="password-input"
          type={showPassword ? "text" : "password"}
          rightElement={
            <Icon
              name="eye-open"
              color="#adbdcb"
              className={styles.viewBtn}
              onClick={toggleShowPassword}
            />
          }
          onChange={onPasswordChange}
        />
      </FormGroup>
    </AccountForm>
  );
}

export default RegisterForm;
